/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const title = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="m4 5.5h2v6.5h1.5v-6.5h2v-1.5h-5.5zm16 10.5h-16v-1.5h16zm-7 4h-9v-1.5h9z" />
	</SVG>
);

export default title;
